import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { ErrorBindingService } from '../../services/error-binding.service';


@Component({
    selector: 'app-booking-cancellation',
    templateUrl: './booking-cancellation.component.html',
    standalone: false
})
export class BookingCancellationComponent implements OnInit {
  @Input() bookingID;
  @Output() isPopSave: EventEmitter<any> = new EventEmitter();
  @Output() isPopCancel: EventEmitter<any> = new EventEmitter();
  packageApiError: any = [{
    pickupLocationName: false,
    cancelReason: false
  }];

  bookingCancelForm = new UntypedFormGroup({
    cancelReason: new UntypedFormControl(),
  });
  labelSave;
  labelCancel;
  labelCancellation;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private commonBindingDataService: CommonBindingDataService,
    private errorBindingService: ErrorBindingService) { }

  ngOnInit() {
    this.bookingCancelForm = this.formBuilder.group({
      cancelReason: ['', [Validators.required]]
    });
    this.labelSave = this.commonBindingDataService.getLabel('label_booking_cancel');
    this.labelCancel = this.commonBindingDataService.getLabel('label_cancel');
    this.labelCancellation = this.commonBindingDataService.getLabel('label_cancellation');

  }
  cancelBooking() {
    const data = {
      cancellationReason: this.bookingCancelForm.controls.cancelReason.value
    };
    this.commonBindingDataService.cancelBooking(this.bookingID, data).subscribe(results => {
      this.successSave('success', results);
    }, (error) => {

      this.successSave('Error', error);
    });
  }

  successSave(message, results) {
    this.errorBindingService.setMessage({ severity: message, summary: message, detail: results.general[0].message });
    this.bookingCancelForm.reset();

    setTimeout(() => {
      this.isPopSave.emit(results);
    }, 2000);
  }

  cancel() {
    this.isPopCancel.emit();
  }

}
